import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Espaces dédiés : le lien direct ouvre la connexion de cet espace
const ESPACES = { '/portail-financeur': 'financeur', '/portail-client': 'client', '/portail-candidat': 'candidat', '/portail-formateur': 'formateur' };
import { useAuth } from '../../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (!user) {
    const espace = ESPACES[location.pathname];
    const pages = { financeur: '/login-financeur', client: '/login-entreprise', candidat: '/login-candidat', formateur: '/login-formateur' };
    return <Navigate to={espace ? pages[espace] : '/login'} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // super_admin has all admin access
    if (user.role === 'super_admin' && allowedRoles.includes('admin')) {
      return children;
    }
    // Redirect candidats to their portal instead of dashboard
    if (user.role === 'candidat') {
      return <Navigate to="/portail-candidat" replace />;
    }
    // Redirect formateurs to their portal
    if (user.role === 'formateur') {
      return <Navigate to="/portail-formateur" replace />;
    }
    // Redirect commercials to their space
    if (user.role === 'commercial') {
      return <Navigate to="/commercial" replace />;
    }
    if (user.role === 'client') {
      return <Navigate to="/portail-client" replace />;
    }
    if (user.role === 'financeur') {
      return <Navigate to="/portail-financeur" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
